import { axiosRequest } from '../../utils/Requests.js';

export default {
    data() {
        return {
            loading: true,
            imobiliaria: {},
            rota: this.$router.currentRoute.name,
            urlMapaEstatico: null,
            urlPlace: null,
            windowWidth: window.innerWidth,
            isScrolled: false,
        }
    },

    computed: {
      somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
      somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
      ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

      numeroWhatsApp() {
        if(this.somenteAluguel) { return this.imobiliaria.whatsappAluguel; }
        if(this.somenteVenda) { return this.imobiliaria.whatsappVenda; }
        if(this.ambos) { return this.imobiliaria.whatsappAluguel; }
  
        return undefined;
      },
      numeroWhatsAppSemFormatacao() {
        if(this.somenteAluguel) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
        if(this.somenteVenda) { return this.imobiliaria.whatsappVendaSemFormatacao; }
        if(this.ambos) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
        
        return undefined;
      },

      isMapaVisible() {
        return this.urlMapaEstatico != null;
      },

      exibirBotaoWhatsapp() {
        if (!this.imobiliaria.whatsappVenda && !this.imobiliaria.whatsappAluguel) {
          return false;
        }

        const path = this.$route ? this.$route.path : '';
        const nomeRota = this.rota;
        const isMobile = this.windowWidth < 768;

        if (isMobile) {
          return path === '/' || !nomeRota;
        } else {
          const rotasProibidasDesktop = ['imovel', 'quemSomos', 'anuncieImovel'];
          return !rotasProibidasDesktop.includes(nomeRota);
        }
      }
    },

    mounted() {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    },

    beforeRouteEnter(to, from, next) {
      axiosRequest.get("/index")
        .then((resultado) => {
          if (!resultado.data.parametros) resultado.data.parametros = {};
          resultado.data.parametros.menuBranco = false;
          next(vm => vm.setData(resultado.data))
        }).catch((erro) => {
          // eslint-disable-next-line no-console
          console.log(erro);
        });
    },
    
    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth;
      },

      handleScroll() {
        this.isScrolled = window.scrollY > 30;
      },

      setData(imobiliaria) {
          this.imobiliaria = imobiliaria

          this.setUrlMapaEstatico(imobiliaria.urlMapaEstatico)
          this.setUrlPlace(imobiliaria.urlPlace)
          this.loading = false
      },

      setUrlMapaEstatico(url) {
        this.urlMapaEstatico = url;
      },

      setUrlPlace(url) {
        this.urlPlace = url;
      },

      alterarRota(nome) {
          this.rota = nome
      },

      irParaPagina(nome) {
          this.$router.push({ name: nome })
          this.rota = nome
      }
    },

    watch: {
      '$route'() {
          this.rota = this.$router.currentRoute.name
      }
    }
}